import { isValidEmail, isValidPassword } from 'app/shared/utils/validators';
import { INVALID_EMAIL_ERROR_MSG } from 'app/shared/utils/errorMessages';

/**
 * Handles the email validation and returns the appropriate error message or empty string
 * @param {string} value - the email address that needs to be validated
 * @returns {string} - the error message or an empty string
 */
export const handleEmailValidation = (value) =>
  isValidEmail(value) ? '' : INVALID_EMAIL_ERROR_MSG;

/**
 * Handles the password validation and returns the appropriate error message or empty string
 * @param {string} value - the password that needs to be validated
 * @returns {string} - the error message or an empty string
 */
export const handlePasswordValidation = (value) =>
  isValidPassword(value)
    ? ''
    : 'Passwort sollte mindestens 8 Zeichen lang sein.';

/**
 * Handles the checkbox validation and returns the appropriate error message or empty string
 * @param {string} value - the password that needs to be validated
 * @returns {string} - the error message or an empty string
 */
export const handleCheckboxValidation = (value) => (value ? '' : 'required');
